import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetEntitiesEntityIdSuspense } from "api/generated/entities/entities";

export function useEntityQuery(entityId: number) {
    return useGetEntitiesEntityIdSuspense(entityId, {
        query: {
            select: (response) => response.data,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
